import { reduxForm } from 'redux-form';
import Component from './EditAgentForm';
import { initialValues, validate } from './schema';

const EditAgentForm = reduxForm({
  form: 'EditAgentForm',
  initialValues: initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default EditAgentForm;
